<template>
  <div class="main-page">
    <Menu
      title="评价查看"
      :home="true"
    />
    <div class="container-flex">
      <div class="look-evaluation">
        <div class="look-title">
          法律援助律师工作证颁发
        </div>
        <div class="look-evaluation">
          <table>
            <tr class="top-line">
              <td class="left-lable">实施单位</td>
              <td
                width="30%"
                class="lable"
              >云南省司法厅</td>
              <td class="left-lable">到现场办理的次数</td>
              <td
                width="30%"
                class="lable"
              >无特别说明</td>
            </tr>
            <tr>
              <td class="left-lable">法定办结时限</td>
              <td
                width="30%"
                class="lable"
              >30日</td>
              <td class="left-lable">办理时间</td>
              <td
                width="30%"
                class="lable"
              >2020-04-14 11:37:19</td>
            </tr>
            <tr>
              <td class="left-lable">是否收费</td>
              <td
                width="30%"
                class="lable"
              >无特别说明</td>
              <td class="left-lable">办理地点</td>
              <td
                width="30%"
                class="lable"
              >无特别说明</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '../../components/Menu'
export default {
  components: {
    Menu
  }
}
</script>

<style lang="stylus" scoped>
.look-evaluation
  width 10.8rem
  margin 0 auto
  color #fff
  .look-title
    font-size 0.3rem
  .look-evaluation
    margin-top 20px
    .hts
      font-size 16px
      padding-bottom 15px
    table
      width 100%
      border-collapse collapse
      font-size 16px
      border 1px solid rgba(255, 255, 255, 0.2)
    td
      text-align center
      padding 14px 27px
      border 1px solid rgba(255, 255, 255, 0.2)
      font-size 15px
      font-weight 600
      &.lable
        font-weight normal
      &.left-lable
        background rgba(255, 255, 255, 0.08)
    tr
      width 100%
</style>
